// src/components/MainView.js
import React from "react";
import { useNavigate } from "react-router-dom";

const MainView = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-4 py-md-5" id="mainView">
      <div className="row row-cols-1 row-cols-md-2 g-4 g-lg-5 justify-content-center">
        {/* 1. Социальные выплаты */}
        <div className="col">
          <div
            className="icon-block rub-icon"
            onClick={() => navigate("/payouts")}
          >
            <h2 className="label-top">Социальные выплаты</h2>
            <div className="logo-container">
              <img
                src="/img/komitet.jpg.c1200.png"
                alt="Логотип"
                className="logo-img"
              />
            </div>
            <div className="rub-stamp">₽</div>
          </div>
        </div>

        {/* 2. Здравоохранение */}
        <div className="col">
          <div
            className="icon-block health-icon"
            onClick={() => navigate("/health")}
          >
            <h2 className="label-top">Здравоохранение</h2>
            <div className="logo-container">
              <img
                src="/img/photo_2025-11-24_11-06-24.jpg"
                alt="Здравоохранение"
                className="logo-img"
              />
            </div>
          </div>
        </div>

        {/* 3. ТСР */}
        <div className="col">
          <div className="icon-block tsr-icon" onClick={() => navigate("/tsr")}>
            <h2 className="label-top">Технические средства реабилитации</h2>
            <div className="logo-container">
              <img
                src="/img/photo_2025-12-03_11-12-19.jpg"
                alt="ТСР"
                className="logo-img"
              />
            </div>
          </div>
        </div>

        {/* 4. Труд и занятость */}
        <div className="col">
          <div
            className="icon-block work-icon"
            onClick={() => navigate("/work")}
          >
            <h2 className="label-top">Труд и занятость</h2>
            <div className="icon-inner">
              <svg viewBox="0 0 200 200" className="work-svg">
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="#fff3e0"
                  stroke="#ef6c00"
                  strokeWidth="8"
                />
                <rect
                  x="60"
                  y="70"
                  width="80"
                  height="60"
                  rx="15"
                  fill="#ff9800"
                />
                <circle
                  cx="100"
                  cy="95"
                  r="20"
                  fill="#fff"
                  stroke="#ef6c00"
                  strokeWidth="4"
                />
                <path
                  d="M80 110 L100 130 L120 110"
                  stroke="#ef6c00"
                  strokeWidth="8"
                  fill="none"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* 5. Юридическая помощь */}
        <div className="col">
          <div className="icon-block law-icon" onClick={() => navigate("/law")}>
            <h2 className="label-top">Юридическая помощь</h2>
            <div className="icon-inner">
              <svg viewBox="0 0 200 200">
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="#f3e5f5"
                  stroke="#7b1fa2"
                  strokeWidth="8"
                />
                <rect
                  x="70"
                  y="60"
                  width="60"
                  height="80"
                  rx="8"
                  fill="#9c27b0"
                />
                <rect x="80" y="70" width="40" height="6" fill="#fff" />
                <rect x="80" y="85" width="40" height="6" fill="#fff" />
                <rect x="80" y="100" width="30" height="6" fill="#fff" />
                <path d="M100 130 L85 150 L115 150 Z" fill="#7b1fa2" />
              </svg>
            </div>
          </div>
        </div>

        {/* 6. Образование */}
        <div className="col">
          <div className="icon-block edu-icon" onClick={() => navigate("/edu")}>
            <h2 className="label-top">Образование</h2>
            <div className="icon-inner">
              <svg viewBox="0 0 200 200">
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="#e8f5e8"
                  stroke="#388e3c"
                  strokeWidth="8"
                />

                <circle
                  cx="100"
                  cy="60"
                  r="20"
                  fill="#fff"
                  stroke="#388e3c"
                  strokeWidth="4"
                />

                <rect
                  x="80"
                  y="80"
                  width="40"
                  height="70"
                  fill="#4caf50"
                  rx="5"
                  ry="5"
                />

                <path
                  d="M80 100 L60 120 M120 100 L140 120"
                  stroke="#388e3c"
                  strokeWidth="6"
                />

                <rect
                  x="60"
                  y="110"
                  width="80"
                  height="60"
                  fill="#fff"
                  stroke="#388e3c"
                  strokeWidth="4"
                  rx="5"
                  ry="5"
                />

                <rect x="95" y="110" width="10" height="60" fill="#2e7d32" />

                <line
                  x1="65"
                  y1="120"
                  x2="95"
                  y2="120"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="65"
                  y1="130"
                  x2="95"
                  y2="130"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="65"
                  y1="140"
                  x2="95"
                  y2="140"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="65"
                  y1="150"
                  x2="95"
                  y2="150"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="65"
                  y1="160"
                  x2="95"
                  y2="160"
                  stroke="#388e3c"
                  strokeWidth="2"
                />

                <line
                  x1="105"
                  y1="120"
                  x2="135"
                  y2="120"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="105"
                  y1="130"
                  x2="135"
                  y2="130"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="105"
                  y1="140"
                  x2="135"
                  y2="140"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="105"
                  y1="150"
                  x2="135"
                  y2="150"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
                <line
                  x1="105"
                  y1="160"
                  x2="135"
                  y2="160"
                  stroke="#388e3c"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* 7. Спорт */}
        <div className="col">
          <div
            className="icon-block sport-icon"
            onClick={() => navigate("/sport")}
          >
            <h2 className="label-top">Спорт</h2>
            <div className="icon-inner">
             <svg viewBox="0 0 200 200">
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="#fff8e1"
                  stroke="#f57f17"
                  strokeWidth="8"
                />
                <circle cx="100" cy="100" r="50" fill="#ffc107" />
                <path
                  d="M70 70 Q100 30 130 70"
                  stroke="#f57f17"
                  strokeWidth="12"
                  fill="none"
                />
                <path
                  d="M70 130 Q100 170 130 130"
                  stroke="#f57f17"
                  strokeWidth="12"
                  fill="none"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* 8. Культура и туризм */}
        <div className="col">
          <div
            className="icon-block culture-icon"
            onClick={() => navigate("/culture")}
          >
            <h2 className="label-top">Культура и туризм</h2>
            <div className="icon-inner">
              <svg viewBox="0 0 200 200">
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="#e1f5fe"
                  stroke="#0277bd"
                  strokeWidth="8"
                />
                <path
                  d="M60 100 Q100 40 140 100 Q100 160 60 100"
                  fill="#29b6f6"
                />
                <circle cx="80" cy="85" r="12" fill="#fff" />
                <circle cx="120" cy="85" r="12" fill="#fff" />
                <rect
                  x="70"
                  y="120"
                  width="60"
                  height="20"
                  rx="10"
                  fill="#0277bd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainView;